import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { DarkScreenMask, Dropdown } from '@myplay/ui';
// import Upload from "@myplay/all/src/utils/videoUpload/Upload";
import { utils } from "@myplay/all";
import closeIcon from '../../assets/icons/Icon-Close.svg';
import youTubeIcon from '../../assets/icons/youtube-upload.svg';
import uploadIcon from '../../assets/icons/Icon-Upload-Computer.svg';
import { capitalize } from '../../utils/stringManipulations';
import { NAME } from '../../utils/constants';
import I18N from '../../I18N';
import YoutubeUpload from './YoutubeUpload';
import ComputerUpload from './ComputerUpload';
import './UploadVideoModal.scss';

const COMPUTER = "computer";
const YOUTUBE = "youtube";

const upload = utils.Upload;
class UploadVideoModal extends Component {
  static propType = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    teams: PropTypes.array,
    VideosStore: PropTypes.object  
  };

  static defaultProps = {
    isVisible: false,
    onClose: ()=> {},
    teams: [], 
    VideosStore: {}
  };

  state = {
    selectedTeam: null,
    displayedMethod: null,
    filePath: "", 
    file: null
  };

  handleTeamSelect = selectedTeam => {
    this.setState({
      selectedTeam
    })
  };

  handlePickMethod = method => {
    const { selectedTeam } = this.state;

    if (!selectedTeam) {
      return;
    };

    this.setState({ displayedMethod: method })
  };

  handleFileSelect = event => {
    this.setState({
      filePath: event.target.value, 
      file: event.target.files[0]
    });
  };

  handleUploadFile = async () => {
    const { VideosStore, NotificationsStore } = this.props;
    const { filePath, selectedTeam, file } = this.state;

    try {
      const { uploadUrl, requestId } = await VideosStore.uploadVideoFromComputer(filePath, selectedTeam);
      // console.log("uploadUrl ", uploadUrl, requestId);
      NotificationsStore.addClientUploadTasks(requestId, filePath);
      // console.log("uploadUrl, requestId ", uploadUrl, requestId);
      this.upload = new upload({
        id: filePath,
        url: uploadUrl,
        file,
        onChunkUpload: info => {
          
          const percent = Math.ceil(
            (info.uploadedBytes / info.totalBytes) * 100
          );
          
          // console.log('selectedTeam.name ', selectedTeam.name);
          VideosStore.updateUploadPercent(percent, selectedTeam.name);
          const uploadTask = NotificationsStore.clientUploadTasks.find(
            task => task.requestId === requestId
          );
          if (uploadTask) {
            uploadTask.setTaskProcess(percent);
          }
        }
      });

      // console.log("this.upload ", this.upload);
      
      try {
        // this.setState({ isUploadStarted: true });
        this.close();
        await this.upload.start();
        await NotificationsStore.removeClientUploadTasks(requestId);
        await VideosStore.updateUploadVideoRequest(requestId);
        await NotificationsStore.getActiveTasks();
      } catch (e) {
        console.log(e.message);
      } finally {
        this.upload = null;
        VideosStore.updateUploadPercent(null);
      }
    } catch (e) {
      console.log(e);
    }
  };

  handleUploadFromYoutube = async link => {
    const { VideosStore } = this.props;
    const { selectedTeam } = this.state;

    await VideosStore.uploadVideoFromYoutube(link, selectedTeam);
    this.close();
  }

  close = ()=> {
    const { onClose } = this.props;
    this.setState({
      selectedTeam: null,
      displayedMethod: null,
      youtubeLink: "",
      filePath: "", 
      file: null
    });
    onClose();
  }

  render() {
    const { isVisible, teams } = this.props;
    const { displayedMethod, selectedTeam, filePath } = this.state;

    return (
      <DarkScreenMask isVisible={isVisible}>
        <div className="upload-video-modal" data-testid="upload-video-modal">
          <button className="upload-video-modal__close-button" onClick={this.close}>
            <img src={closeIcon} alt="" />
          </button>
          {!displayedMethod &&
            <Fragment>
              <Dropdown
                items={teams}
                displayedProperty={NAME}
                onSelect={this.handleTeamSelect}
                selectedItem={selectedTeam}
                placeholder={capitalize(I18N.t("CHOOSE_TEAM"))}
              />
              <div className="upload-video-modal__icons-container">
                <button
                  type="button"
                  className="upload-video-modal__icons-container__computer"
                  style={!selectedTeam ? { filter: "grayscale(70)", cursor: 'unset' } : {}}
                  onClick={() => this.handlePickMethod(COMPUTER)}
                  data-testid="upload-computer"
                >
                  <img src={uploadIcon} alt="" />
                  <span>{capitalize(I18N.t("FROM_COMPUTER"))}</span>
                </button>
                <button
                  type="button"
                  className="upload-video-modal__icons-container__youtube"
                  style={!selectedTeam ? { filter: "grayscale(70)", cursor: 'unset' } : {}}
                  onClick={() => this.handlePickMethod(YOUTUBE)}
                  data-testid="upload-youtube"
                >
                  <img src={youTubeIcon} alt="" />
                  <span>{capitalize(I18N.t("FROM_YOUTUBE"))}</span>
                </button>
              </div>
            </Fragment>
          }
          {displayedMethod === YOUTUBE &&
            <YoutubeUpload
              onBack={() => this.handlePickMethod(null)}
              onUploadApprove={this.handleUploadFromYoutube}
            />
          }
          {displayedMethod === COMPUTER &&
            <ComputerUpload
              filePath={filePath}
              onBack={() => this.handlePickMethod(null)}
              onChange={this.handleFileSelect}
              onUpload={this.handleUploadFile}
            />
          }
        </div>
      </DarkScreenMask>
    );
  }
}

export default inject("VideosStore", "NotificationsStore")(observer(UploadVideoModal));